import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import PageBase from "../../components/PageBase";
import ClosedWon from "./Widgets/ClosedWon";
import PipelineStatus from "./Widgets/PipelineStatus";
import HotOpportunities from "./Widgets/HotOpportunities";
import TouchbaseChampions from "./Widgets/TouchbaseChampions";
import MarketingEvents from "./Widgets/MarketingEvents";
import MarketingAssets from "./Widgets/MarketingAssets";
import FundsList from "./Widgets/FundsList";
import * as ROUTES from '../../utils/routes';
import FundsReceived from "./Widgets/FundsReceived";
import constants from "../../utils/constants.js";

import './Home.scss';
import './Widgets/Widgets.scss';
import * as programActions from "../../redux/Program/actions.js";
import {appendProgramsCategories} from "./programUtils.js";
import PartnershipCategoryValue from "./PartnershipCategoryValue";

const Home = props => {
	const navigate = useNavigate();
	const programs = useSelector(state => state.program).programs;
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			await dispatch(programActions.loadPrograms([]));
		};
		load();
	}, []);

	useEffect(() => {
		const load = async () => {
			let menuData = await localStorage.getItem(constants.MENU_DATA);
			menuData = JSON.parse(menuData);
			if(menuData && menuData.route) {
				navigate(menuData.route);
			}
		};
		load();
	}, []);

	const showReport = (title, data, selectedObject) => {
		navigate(ROUTES.DASHBOARD_REPORT, { state: { title, data, selectedObject } });
	};

	let programsWithCategories = [];

	if(programs) {
		programsWithCategories = appendProgramsCategories(programs);
	}

	return (
		<PageBase title="Home" removeMargins>
			<div className="home-partnership-summary">
				<b>Partnership Status</b>
				<div style={{display: 'flex', columnGap: '30px'}}>
					<PartnershipCategoryValue showFloater programs={programsWithCategories.filter(p => p.category === 'Tier')} item="Tier" />
					<PartnershipCategoryValue showFloater programs={programsWithCategories.filter(p => p.category === 'Compensation')} item="Compensation" />
					<PartnershipCategoryValue showFloater programs={programsWithCategories.filter(p => p.category === 'Differentiation')} item="Differentiation" />
					<PartnershipCategoryValue showFloater programs={programsWithCategories.filter(p => p.category === 'Promotion')} item="Promotion" />
					<PartnershipCategoryValue showFloater programs={programsWithCategories.filter(p => p.category === 'Integration')} item="Integration" />
				</div>
			</div>
			<div className="widgets-container" style={{gridTemplateColumns: '1fr 1fr 1fr', padding: '0 30px', width: 'calc(100% - 60px)'}}>
				<ClosedWon showReport={widget => showReport('Closed Won Opportunities', widget.data.data, 'opportunities')} />
				<PipelineStatus showReport={widget => showReport('Pipeline Status', widget.data.data, 'opportunities')} />
				<HotOpportunities showReport={widget => showReport('Hot Opportunities', widget.data.data, 'opportunities')} />
				<TouchbaseChampions showReport={widget => showReport('Touchbase Champions', widget.data.data, 'heatmaps')} />
				<MarketingEvents showReport={widget => showReport('Marketing Events', widget.data.data, 'marketing')} />
				<MarketingAssets showReport={widget => showReport('Marketing Assets', widget.data.data, 'marketing')} />
				<FundsList showReport={widget => showReport('Funds Pipeline', widget.data.data, 'funds')} />
				<FundsReceived showReport={widget => showReport('Funds Received', widget.data.data, 'funds')} />
			</div>
		</PageBase>
	);
};

export default Home;
